import React, { useEffect, useState } from 'react'
import './test.css'
import axios from 'axios';

export default function Test() {
  const [image, setImage] = useState(null);
  const [annotatedImage, setAnnotatedImage] = useState(null);
  const [icons, setIcons] = useState([]);

  const data = async () => {
    try {
      let response = await axios.get(
        "http://192.168.110.17:8005/process",
      );
      console.log(response.data);
      setImage(response?.data?.image);
      setAnnotatedImage(response?.data?.annotated_image_url);
      setIcons(response?.data?.icons);
      console.log(icons);
    } catch (error) {
      console.log(error.message);
    }
  };
  
  useEffect(() => {
    data();
  });

  return (
    <div
      className=" test-section mx-auto"
      style={{
        height: image?.height,
        width: image?.width,
        backgroundImage: `url(${annotatedImage})`,
      }}
    >
      {icons.map((icon) => (
        <div
          className="image-position-test"
          onClick={() => alert(icon.info?.الاسم)}
          style={{
            left: `${icon?.bbox_px[0]}px`,
            top: `${icon?.bbox_px[1]}px`,
          }}
        >
          <img src={icon.crop_url} alt="" />
        </div>
      ))}
    </div>
  );
}










